import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  advantageSectionContent,
  benefitsSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/college-storage-fee-page'

interface CollegeStorageFeePageProps {}

const CollegeStorageFeePage: React.FC<CollegeStorageFeePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
      w-[324px] h-[218px] 
      md-mn:w-[380px] md-mn:h-[286px] 
      lg:!w-[448px] lg:!h-[313px] 
      xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[311px] xl-min:!h-[50px] w-[254px] h-[44px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full
          md-mn:[&_article]:px-0 
          [&_article]:px-6
          [&_h3]:text-center 
          xl-min:[&_button]:!w-[311px] 
          [&_button]:w-[254px] 
          `}
      />
      <HelperSection
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        sectionTitleClassName='md-mn:w-full w-[80%]'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} />
      <ServiceTipsSectionSection
        {...benefitsSectionContent}
        className={`
        [&_article]:text-center
        [&_article_div]:w-full
        md-mn:[&_article]:px-0 
        [&_article]:px-6
        [&_h3]:text-center 
        `}
      />
      <WhyWeSection
        isBgDark
        {...advantageSectionContent}
        className='
        [&_article]:bg-transparent 
        [&_article]:border-none 
        [&_article]:text-center 
        [&_article>div]:self-center
        [&_article_img]:w-[130px]
        [&_article_img]:h-[130px]
        '
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
            xl-min:[&_h3]:!w-[90%]
            [&_h3]:w-full
            md-mn:[&_button]:w-[281px]
            [&_button]:w-[280px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} sectionTitleClassName='md-mn:w-full w-[80%]' />
    </>
  )
}

export default CollegeStorageFeePage
